// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './i18n/fr.json';
import en from './i18n/en.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: 'fr',           // langue par défaut -> français
    fallbackLng: 'fr',   // si une traduction manque -> français
    interpolation: {
      escapeValue: false
    },
  });

export default i18n;
